/* Loovi fit finder — breed data and verdict logic.
   Markup and settings live in sections/lv-pdp-sizefinder.liquid, which passes
   the size thresholds through data attributes on [data-lv-bf].

   Verdicts are judged on each breed's TYPICAL MIDPOINT, not its full spread:
   every breed's range straddles something, so using the spread makes nearly
   everything read as borderline.

   "stretch" is how far past the top of Large a breed can sit before we stop
   calling it a plain Large and flag it as our biggest size. Without it, the
   currently published 42cm back-length ceiling flags a Beagle, which is
   misleading — the straps carry that much. */
(function () {
  var RAW = [
    ['Affenpinscher','',36,46,25,33],['Airedale Terrier','',66,81,48,58],
    ['Akita','',79,97,56,69],['Alaskan Malamute','',76,94,56,69],
    ['American Staffordshire Terrier','Amstaff,Pit Bull,Pitbull',66,81,46,56],
    ['Australian Cattle Dog','Blue Heeler,Red Heeler,Heeler',66,79,46,56],
    ['Australian Kelpie','Kelpie',61,74,45,55],
    ['Australian Shepherd','Aussie Shepherd',66,81,48,58],
    ['Australian Terrier','',38,48,26,33],['Basenji','',46,56,36,43],
    ['Basset Hound','',61,76,43,53],['Beagle','',53,66,38,48],
    ['Bedlington Terrier','',46,56,36,43],['Bernese Mountain Dog','Berner',84,104,61,74],
    ['Bichon Frise','',41,51,28,36],['Border Collie','',61,76,46,56],
    ['Border Terrier','',41,51,30,38],['Boston Terrier','',48,61,33,41],
    ['Boxer','',74,89,53,64],['Brittany','Brittany Spaniel',58,71,43,53],
    ['Bull Arab','',79,97,58,71],['Bull Terrier','',66,79,46,56],
    ['Bullmastiff','',89,112,61,76],['Cairn Terrier','',41,48,28,34],
    ['Cane Corso','',86,107,61,76],
    ['Cavalier King Charles Spaniel','Cavalier,King Charles',43,53,30,38],
    ['Cavoodle','Cavapoo',43,58,30,40],['Chihuahua','',33,43,20,28],
    ['Chinese Crested','',33,43,23,30],['Chow Chow','',71,86,48,58],
    ['Cocker Spaniel','',53,66,38,48],['Coton de Tulear','',38,48,25,33],
    ['Dachshund (Miniature)','Mini Dachshund,Mini Sausage Dog',33,43,26,33],
    ['Dachshund (Standard)','Sausage Dog,Doxie',43,53,35,45],
    ['Dalmatian','',71,86,53,64],['Doberman Pinscher','Dobermann',76,91,58,69],
    ['Dogue de Bordeaux','',89,112,61,76],
    ['English Bulldog','British Bulldog,Bulldog',66,81,41,51],
    ['English Setter','',71,86,53,66],
    ['English Springer Spaniel','Springer Spaniel',61,74,43,53],
    ['Fox Terrier','',43,53,30,38],['French Bulldog','Frenchie',53,66,33,41],
    ['German Shepherd','GSD,Alsatian',79,99,58,70],
    ['German Shorthaired Pointer','GSP,Pointer',66,81,51,61],
    ['Golden Retriever','',76,94,56,66],['Goldendoodle','Groodle',66,89,48,62],
    ['Great Dane','',91,117,71,86],['Greyhound','',71,84,58,69],
    ['Havanese','',38,48,25,33],['Irish Setter','',71,86,53,66],
    ['Italian Greyhound','Iggy',38,46,30,38],
    ['Jack Russell Terrier','Jack Russell,JRT',41,51,28,36],
    ['Koolie','German Coolie',61,74,45,55],
    ['Labrador Retriever','Labrador,Lab',76,94,56,66],
    ['Labradoodle','',66,89,48,62],['Lhasa Apso','',43,53,26,34],
    ['Maltese','',35,43,22,30],['Maltese Shih Tzu','Malshi',38,48,24,32],
    ['Miniature Fox Terrier','Mini Foxie',36,46,25,33],
    ['Miniature Pinscher','Min Pin',36,46,25,33],
    ['Miniature Schnauzer','',43,53,30,38],['Moodle','Maltipoo',36,46,23,31],
    ['Newfoundland','',89,114,66,81],['Papillon','',35,43,23,30],
    ['Pekingese','',43,53,25,33],['Pomeranian','Pom',36,46,23,30],
    ['Poodle (Miniature)','Mini Poodle',43,53,30,38],
    ['Poodle (Standard)','',68,86,50,62],['Poodle (Toy)','',35,43,23,30],
    ['Pug','',48,58,30,38],['Pyrenean Mountain Dog','Great Pyrenees',86,107,64,79],
    ['Rhodesian Ridgeback','Ridgeback',79,97,58,71],
    ['Rottweiler','Rottie',86,107,61,74],['Saint Bernard','',91,117,66,81],
    ['Samoyed','',66,84,51,61],['Schnoodle','',43,56,30,40],
    ['Scottish Terrier','Scottie',46,56,30,38],['Shar Pei','',66,81,46,56],
    ['Shetland Sheepdog','Sheltie',51,61,38,46],['Shiba Inu','',53,64,38,48],
    ['Shih Tzu','',43,53,26,33],['Siberian Husky','Husky',66,84,51,61],
    ['Silky Terrier','',36,46,24,31],
    ['Soft Coated Wheaten Terrier','Wheaten Terrier',56,69,41,51],
    ['Spoodle','Cockapoo',46,61,33,43],
    ['Staffordshire Bull Terrier','Staffy,Staffie,Staff',61,74,41,51],
    ['Tenterfield Terrier','Rat Terrier',38,48,27,35],['Vizsla','',66,81,51,61],
    ['Weimaraner','',74,89,56,66],['Welsh Corgi (Pembroke)','Corgi',53,66,38,48],
    ['West Highland White Terrier','Westie',43,53,28,36],
    ['Whippet','',56,66,43,53],['Yorkshire Terrier','Yorkie',33,41,20,28]
  ];

  var BREEDS = RAW.map(function (r) {
    return { n: r[0], a: r[1] ? r[1].split(',') : [], c: [r[2], r[3]], b: [r[4], r[5]] };
  });

  function num(el, key, fallback) {
    var v = parseFloat(el.dataset[key]);
    return (isFinite(v) && v > 0) ? v : fallback;
  }

  function init(root) {
    var cfg = {
      smallChest: num(root, 'smallChest', 50),
      largeChest: num(root, 'largeChest', 68),
      smallBack: num(root, 'smallBack', 30),
      largeBack: num(root, 'largeBack', 42),
      stretch: num(root, 'stretch', 1.35)
    };

    var input = root.querySelector('[data-lv-bf-input]');
    var list = root.querySelector('[data-lv-bf-list]');
    var clear = root.querySelector('[data-lv-bf-clear]');
    var result = root.querySelector('[data-lv-bf-result]');
    var sizeEl = root.querySelector('[data-lv-bf-size]');
    var chipEl = root.querySelector('[data-lv-bf-chip]');
    var lineEl = root.querySelector('[data-lv-bf-line]');
    if (!input || !list) return;

    function judge(lo, hi, smallMax, largeMax) {
      var mid = (lo + hi) / 2;
      var tol = Math.max(2, (largeMax - smallMax) * 0.22);
      if (mid > largeMax * cfg.stretch) return { size: 'Large', state: 'beyond' };
      if (mid <= smallMax) {
        return { size: 'Small', state: (smallMax - mid) <= tol ? 'close' : 'clear' };
      }
      return { size: 'Large', state: (mid - smallMax) <= tol ? 'close' : 'clear' };
    }

    function verdict(breed) {
      var c = judge(breed.c[0], breed.c[1], cfg.smallChest, cfg.largeChest);
      var b = judge(breed.b[0], breed.b[1], cfg.smallBack, cfg.largeBack);
      if (c.state === 'beyond' || b.state === 'beyond') {
        return { size: 'Large', chip: 'Our biggest size', cls: '', state: 'beyond' };
      }
      if (c.state === 'close' || b.state === 'close' || c.size !== b.size) {
        return { size: c.size, chip: 'Most take ' + c.size, cls: 'close', state: 'close' };
      }
      return { size: c.size, chip: 'Clear fit', cls: 'ok', state: 'clear' };
    }

    function show(breed) {
      var v = verdict(breed);
      sizeEl.textContent = v.size;
      chipEl.textContent = v.chip;
      chipEl.className = 'lv-bf__chip' + (v.cls ? ' lv-bf__chip--' + v.cls : '');
      var line;
      if (v.state === 'beyond') {
        line = breed.n + 's sit at the top of what we make, so <strong>Large</strong> is the one. Let the chest and belly straps out most of the way.';
      } else if (v.state === 'close') {
        line = breed.n + 's sit right on the line between the two sizes. Most take a <strong>' + v.size + '</strong>.';
      } else {
        line = 'A typical ' + breed.n + ' takes a <strong>' + v.size + '</strong>.';
      }
      lineEl.innerHTML = line;
      result.hidden = false;
    }

    var matches = [];
    var active = -1;

    function filter(q) {
      q = (q || '').trim().toLowerCase();
      if (!q) return BREEDS.map(function (b) { return { b: b, shown: b.n }; });
      var starts = [], contains = [];
      BREEDS.forEach(function (b) {
        var names = [b.n].concat(b.a);
        var hit = null, pos = 99;
        names.forEach(function (nm) {
          var i = nm.toLowerCase().indexOf(q);
          if (i > -1 && i < pos) { pos = i; hit = nm; }
        });
        if (hit === null) return;
        (pos === 0 ? starts : contains).push({ b: b, shown: hit });
      });
      return starts.concat(contains).slice(0, 40);
    }

    function draw(q) {
      matches = filter(q);
      list.innerHTML = '';
      if (!matches.length) {
        var none = document.createElement('li');
        none.className = 'is-none';
        none.textContent = 'No match — email us and we will help';
        list.appendChild(none);
      } else {
        matches.forEach(function (m, i) {
          var li = document.createElement('li');
          li.id = root.id + '-opt-' + i;
          li.setAttribute('role', 'option');
          li.setAttribute('aria-selected', String(i === active));
          li.innerHTML = m.shown === m.b.n
            ? m.b.n
            : m.b.n + '<span class="lv-bf__aka">' + m.shown + '</span>';
          li.addEventListener('mousedown', function (e) { e.preventDefault(); pick(m.b); });
          list.appendChild(li);
        });
      }
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }

    function highlight(i) {
      var items = list.querySelectorAll('[role="option"]');
      if (!items.length) return;
      active = (i + items.length) % items.length;
      Array.prototype.forEach.call(items, function (li, n) {
        li.setAttribute('aria-selected', String(n === active));
        if (n === active) {
          input.setAttribute('aria-activedescendant', li.id);
          li.scrollIntoView({ block: 'nearest' });
        }
      });
    }

    function pick(breed) {
      input.value = breed.n;
      clear.hidden = false;
      close();
      show(breed);
    }

    input.addEventListener('input', function () {
      clear.hidden = input.value.length === 0;
      active = -1;
      result.hidden = true;
      draw(input.value);
    });
    input.addEventListener('focus', function () { draw(input.value); });
    input.addEventListener('blur', function () { window.setTimeout(close, 130); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) draw(input.value); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Enter' && active > -1 && matches[active]) { e.preventDefault(); pick(matches[active].b); }
      else if (e.key === 'Escape') { close(); }
    });
    clear.addEventListener('click', function () {
      input.value = '';
      clear.hidden = true;
      result.hidden = true;
      close();
      input.focus();
    });
  }

  function boot() {
    document.querySelectorAll('[data-lv-bf]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
